// 予約ダイアログの送信payload組み立て（純粋関数）。
// 「フォームから何が送られるか」をコンポーネントのマウント無しでテストするために分離している

// 指名の追加行（ドラフト）を保存時に自動確定する。
// 「追加」の押し忘れで指名が空のまま送信される事故を防ぐ。
// 戻り値: { ok: true, nominations } | { ok: false, error }
export function commitNominationDraft(draft, nominations) {
  const { userId, nominationId } = draft
  if (!userId && !nominationId) return { ok: true, nominations }
  if (!userId || !nominationId) {
    return { ok: false, error: '指名の追加が未完了です。キャストと指名種別を両方選択してください' }
  }

  const exists = nominations.find(n => n.userId === userId && n.nominationId === nominationId)

  return {
    ok: true,
    nominations: exists ? nominations : [...nominations, { userId, nominationId }],
  }
}

// 既存で残っているもの: idを送って保持 / 消えたもの: destroy / 新規: customerId
export function buildCustomersDiff(originalCustomers, currentCustomers) {
  const attrs = []

  originalCustomers.forEach(orig => {
    const kept = currentCustomers.find(c => c.id === orig.id)
    if (kept) {
      attrs.push({ id: orig.reservationCustomerId })
    } else {
      attrs.push({ id: orig.reservationCustomerId, destroy: true })
    }
  })

  const originalIds = originalCustomers.map(o => o.id)
  currentCustomers.forEach(c => {
    if (!originalIds.includes(c.id)) {
      attrs.push({ customerId: c.id })
    }
  })

  return attrs
}

export function buildTagsDiff(originalTags, currentTagIds) {
  const attrs = []

  originalTags.forEach(orig => {
    if (currentTagIds.includes(orig.customerTagId)) {
      attrs.push({ id: orig.id })
    } else {
      attrs.push({ id: orig.id, destroy: true })
    }
  })

  const originalTagIds = originalTags.map(o => o.customerTagId)
  currentTagIds.forEach(tagId => {
    if (!originalTagIds.includes(tagId)) {
      attrs.push({ customerTagId: tagId })
    }
  })

  return attrs
}

// フォーム状態から予約の送信パラメータを組み立てる。
// expectedUpdatedAt は楽観ロック用（編集時のみ。無ければ送らず従来挙動）
export function buildReservationParams(form, {
  isEdit = false,
  originalCustomers = [],
  originalTags = [],
  expectedUpdatedAt = null,
} = {}) {
  const base = {
    reservedDate: form.reservedDate,
    startTime: form.startTime,
    endTime: form.endTime,
    customerCount: form.customerCount,
    hallId: form.hallId,
    tableNumber: form.tableNumber,
    nominations: form.nominations.map(n => ({ userId: n.userId, nominationId: n.nominationId })),
    courseId: form.courseId,
    referralId: form.referralId,
    memo: form.memo,
  }

  if (expectedUpdatedAt) base.expectedUpdatedAt = expectedUpdatedAt

  if (isEdit) {
    base.reservationCustomersAttributes = buildCustomersDiff(originalCustomers, form.customers)
    base.reservationCustomerTaggingsAttributes = buildTagsDiff(originalTags, form.customerTagIds)
  } else {
    base.reservationCustomersAttributes = form.customers.map(c => ({ customerId: c.id }))
    base.reservationCustomerTaggingsAttributes = form.customerTagIds.map(id => ({ customerTagId: id }))
  }

  return base
}
